var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9998 23C28.2931 23 32.5832 18.7099 32.5832 13.4166C32.5832 8.12335 28.2931 3.83331 22.9998 3.83331C17.7065 3.83331 13.4165 8.12335 13.4165 13.4166C13.4165 18.7099 17.7065 23 22.9998 23ZM29.7082 25.3958H28.4578C26.7957 26.1595 24.9465 26.5937 22.9998 26.5937C21.0532 26.5937 19.2114 26.1595 17.5418 25.3958H16.2915C10.7362 25.3958 6.229 29.903 6.229 35.4583V38.5729C6.229 40.5569 7.8387 42.1666 9.82275 42.1666H36.1769C38.161 42.1666 39.7707 40.5569 39.7707 38.5729V35.4583C39.7707 29.903 35.2635 25.3958 29.7082 25.3958Z",
    fill: "#733FE7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClient);
export default __webpack_public_path__ + "static/media/client.0af212ad.svg";
export { ForwardRef as ReactComponent };